const editSVG = `
<svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.14724 2.65318H4.39724C2.82323 2.65318 1.54724 3.92917 1.54724 5.50318V15.0033C1.54724 16.5773 2.82323 17.8533 4.39724 17.8533H13.8972C15.4713 17.8533 16.7472 16.5773 16.7472 15.0033L16.7472 10.2532M6.29724 13.1032L9.75364 12.4067C9.93713 12.3698 10.1056 12.2794 10.2379 12.147L17.9754 4.40528C18.3464 4.0341 18.3461 3.43244 17.9749 3.06158L16.3358 1.42435C15.9647 1.05364 15.3633 1.05389 14.9925 1.42492L7.25418 9.16746C7.12212 9.29959 7.03194 9.46773 6.99494 9.65084L6.29724 13.1032Z" stroke="#908F92" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`

export default editSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/editSVG.js